import {Link} from 'react-router-dom';
import headerImage from '../images/Dwi_Pada_rope_crop.png';

const MainHeader = () => {
  return (
    <header title="Make your practice a constant" className="main__header">
        <div className="main__header-container">
        <div className="main__header-content">
                <h4>Make your practice a constant</h4>
                <h1>#HomePracticeRulz</h1>
                <p>
                At home or in the studio, we're here to support your practice.
                </p>
    <Link to="/pricing" className="btn lg">Get Started</Link>
            </div>
       
        <div className="header__container-bg main__header-image">
            <img src={headerImage} alt="Dwi Pada Viparita Dandasana" />
            
    </div>
        </div>
    </header>
  )
}

export default MainHeader